import * as React from 'react'
import { Row, Col } from 'react-bootstrap'
import JSONPretty from 'react-json-pretty'
import * as immutableBoxStyles from '../styles/immutable-data.module.scss'

const ImmutableData = (props) => {
  return (
    <Row className={immutableBoxStyles.wrapper}>
      <Col xs={12} md={7} className={immutableBoxStyles.box}>

        {props.immutableData &&
          <>
            <p>Immutable Data</p>
            <JSONPretty
              mainStyle='background: white; border:none'
              id='json-pretty'
              data={props.immutableData}
            />
          </>}
        {!props.immutableData && <p>Immutable data not found!</p>}
      </Col>
    </Row>
  )
}

export default ImmutableData
